import React, { useEffect, useState } from "react";
import "./NewActivityIndex.css";
import { useParams, Link } from "react-router-dom";
import activityData from "./ActivityData";
import {
  FaFacebook,
  FaWhatsapp,
  FaLinkedinIn,
  FaTelegramPlane,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";

const NewActivityIndex = () => {
  const { id } = useParams();
  const parsedId = Number(id);
  const [activity, setActivity] = useState(() =>
    activityData.find((item) => item.id === parsedId),
  );
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const found = activityData.find((item) => item.id === parsedId);
    setActivity(found);

    // Ensure top of page for every activity view
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [parsedId]);

  if (!activity)
    return (
      <div className="activity-page activity-loading">
        <div className="activity-loading-text">Loading activity...</div>
      </div>
    );

  const images = activity.gallery || [];
  const url = encodeURIComponent(window.location.href);
  const title = encodeURIComponent(document.title);

  const openSlider = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <>
      <div className="activity-page" key={id}>
        {/* Banner */}
        <div
          className="act-banner"
          style={{
            backgroundImage: activity.banner
              ? `url(${activity.banner})`
              : "none",
          }}
        >
          <h1 className="banner-title">{activity.title}</h1>
          {activity.date && (
            <div className="date-content">
              <span className="banner-divider"></span>
              <h2>{activity.date}</h2>
              <span className="banner-divider"></span>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="activity-container">
          <div className="row shadow-sm rounded p-3">
            <div className={images.length > 0 ? "col-md-8" : "col-md-12"}>
              <div className="activity-content-index">
                <div className="row">
                  <div className={images.length > 0 ? "col-12" : "col-xl-4"}>
                    <div className="activity-media">
                      {activity.img && (
                        <img
                          src={activity.img}
                          alt={activity.title}
                          className="activity-img"
                        />
                      )}

                      {activity.video && (
                        <iframe
                          className="activity-video"
                          src={activity.video.replace("watch?v=", "embed/")}
                          title={activity.title}
                          allowFullScreen
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      images.length > 0
                        ? "col-12 d-flex align-items-center justify-content-center text-center"
                        : "col-xl-8 d-flex"
                    }
                  >
                    <div className="activity-text">
                      <h2 className="activity-title">
                        {activity.title}
                        {activity.date && ` - ${activity.date}`}
                      </h2>

                      <p
                        className="activity-description"
                        dangerouslySetInnerHTML={{
                          __html: activity.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Gallery */}
            {images.length > 0 && (
              <div className="col-md-4">
                <div className="activity-gallery-section">
                  <h2 className="activity-gallery-title">Photo Gallery</h2>

                  <div className="activity-gallery-grid">
                    {images.slice(0, 12).map((photo, index) => (
                      <div
                        className="activity-gallery-item"
                        key={index}
                        onClick={() => openSlider(index)}
                      >
                        <img src={photo} alt={`activity-gallery-${index}`} />
                      </div>
                    ))}
                  </div>
                  <Link
                    to={`/ActivitiesGallery/${activity.id}`}
                    className="viewmore-btn"
                  >
                    View Gallery
                  </Link>
                </div>
              </div>
            )}
          </div>

          {/* Share Buttons */}

          {/* LIGHTBOX */}
          {isOpen && (
            <div className="lightbox-overlay" onClick={() => setIsOpen(false)}>
              <div
                className="lightbox-content"
                onClick={(e) => e.stopPropagation()}
              >
                <button className="close-btn-index" onClick={() => setIsOpen(false)}>
                  &times;
                </button>

                <button className="nav-btn prev-btn" onClick={prevSlide}>
                  &#8249;
                </button>

                <img
                  src={images[currentIndex]}
                  alt="Full size"
                  className="main-slide"
                />

                <button className="nav-btn next-btn" onClick={nextSlide}>
                  &#8250;
                </button>

                <p className="slide-counter">
                  {currentIndex + 1} / {images.length}
                </p>
              </div>
            </div>
          )}
        </div>
        <div
          className="activity-bottom-banner"
          style={{ backgroundImage: `url(${activity.bottombanner})` }}
        >
          <div className="activity-share-section">
            <h2 className="activity-title2">Share this entry</h2>
            <div className="activity-share">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn facebook"
              >
                <FaFacebook className="share-btn-icon" />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${url}&text=${title}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn twitter"
              >
                <FaSquareXTwitter className="share-btn-icon" />
              </a>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn linkedin"
              >
                <FaLinkedinIn className="share-btn-icon" />
              </a>
              <a
                href={`https://t.me/share/url?url=${url}&text=${title}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn telegram"
              >
                <FaTelegramPlane className="share-btn-icon" />
              </a>
              <a
                href={`https://api.whatsapp.com/send?text=${title}%20${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn whatsapp"
              >
                <FaWhatsapp className="share-btn-icon" />
              </a>
              <a
                href={`mailto:?subject=${title}&body=${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn mail"
              >
                <IoMdMail className="share-btn-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewActivityIndex;
